import { UPDATE_AUTH_CUSTOM_FIELD_VALUE_FAILURE } from '../store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { updateAuthCustomFieldValue } from '../store/actions/authorizations.actions';
import { showToast } from 'modules/layout/layout.actions';
import IterativeEditableCard from 'modules/common/iterativeEditableCard.component';
import React, { useState } from 'react';

const CustomFieldValuesCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    customFieldValues,
    fieldStatusesEnum,
    fieldTypesEnum,
    clientCustomFields,
    divisions,
    reloPolicies,
    authFile
  } = props;

  const [customFields, setCustomFields] = useState(customFieldValues ? customFieldValues : []);
  const [currentFieldValues, setCurrentFieldValues] = useState({});

  const fieldStatuses =
    fieldStatusesEnum && fieldStatusesEnum.length > 0
      ? fieldStatusesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const fieldTypes =
    fieldTypesEnum && fieldTypesEnum.length > 0
      ? fieldTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const customFieldTabs = [{ header: 'Custom Fields', order: 1, iconPath: ['fas', 'box-archive'] }];

  let customFieldSummaries = [];

  const parseStringToArray = (string) => {
    if (string && string.length > 0) {
      return string.split(';');
    }
    return [];
  };

  const getStatusType = (status) => {
    return fieldStatuses.find((t) => t.id === status).title.toLowerCase();
  }

  const displayField = (field) => {
    let customField = clientCustomFields && clientCustomFields.length > 0 ? clientCustomFields.find(f => f.customFieldCommonId === field.customFieldCommonId) : null;
        if (customField && customField.customFieldDependencies && customField.customFieldDependencies.length > 0) {
          //check if depedent conditions are met by looping through all dependencies and checking values
          let displayfield = false;

          const dependencyListValues = [];
          let dependencyRequiresField = false;

          const evaluateDependency = (dependency) => {
            let dependentField = dependency.fieldDependentOnId;
            let dependentOperation = dependency.fieldDependentOnOperationId;
            let dependentOnValue = dependency.fieldDependentOnValueId;

            // parse if field is dependent on division or relo policy
            if(dependentField === 'Division') {
              dependentField = 'divisionId';
              const dependentDivisions = parseStringToArray(dependentOnValue);
              dependentOnValue = [];
              dependentDivisions.forEach((division) => {
                if (divisions && divisions.length > 0) {
                  const matchedDivision = divisions.find((div) => div.divisionName === division);
                  if (matchedDivision) {
                    dependentOnValue.push(matchedDivision.clientDivisionId);
                  }
                }
              });
            }
            else if(dependentField === 'Relocation Policy') {
              dependentField = 'relocationPolicyId';
              const dependentPolicies = parseStringToArray(dependentOnValue);
              dependentOnValue = [];
              dependentPolicies.forEach((policy) => {
                if (reloPolicies && reloPolicies.length > 0) {
                  const matchedPolicy = reloPolicies.find((policyItem) => policyItem && policyItem.policy && policyItem.policy.policyDescription === policy);
                  if (matchedPolicy) {
                    dependentOnValue.push(matchedPolicy.policy.relocationPolicyId);
                  }
                }
              });
            }
            else {
              const matchedCustomField = clientCustomFields && clientCustomFields.length > 0
                ? clientCustomFields.find((fieldItem) => fieldItem.fieldLabel === dependentField)
                : null;
              dependentField = matchedCustomField ? matchedCustomField.customFieldCommonId : null;
            }

            const tempFile = authFile
              ? authFile
              : {};
            const matchingCustomFieldValue = dependentField && customFields && customFields.length > 0
              ? customFields.find((fieldItem) => fieldItem.customFieldCommonId === dependentField)
              : null;
            const matchingCustomFieldDefinition = dependentField && clientCustomFields && clientCustomFields.length > 0
              ? clientCustomFields.find((fieldItem) => fieldItem.customFieldCommonId === dependentField)
              : null;
            const currentDependentFieldValue = matchingCustomFieldDefinition
              ? currentFieldValues[matchingCustomFieldDefinition.fieldId]
              : undefined;
            let dependentFieldValue = dependentField === 'relocationPolicyId'
              ? (tempFile.relocationPolicyId ?? tempFile.RelocationPolicyId ?? null)
              : (currentDependentFieldValue ?? tempFile[dependentField] ?? matchingCustomFieldValue?.fieldValue ?? null);

            const candidateValues = Array.isArray(dependentOnValue) ? dependentOnValue : [dependentOnValue];
            const matchesDependency = candidateValues.some((value) => {
              switch (dependentOperation) {
              case '98ba1156-a956-45db-9d68-10f2e345b7f9': // is equal
                return dependentFieldValue === value;
              case '6b8ec837-01c9-4773-ad3c-0e6c41263678': // is not equal
                return dependentFieldValue !== value;
              case '9b12aa29-1027-40a0-9843-8d861d688249': // is not null
                return dependentFieldValue != null && dependentFieldValue !== '';
              case 'd73311f5-41bc-4e0e-8048-92b0722c5bae': // is null
                return dependentFieldValue == null || dependentFieldValue === '';
              case 'e78add1f-2d1c-4241-b15b-2a7dcf12657d': // is greater than
                return dependentFieldValue > value;
              case '01a99433-8b24-4ac8-a004-7e9c8e17c3a0': // is less than
                return dependentFieldValue < value;
              default:
                return false;
              }
            });

            if (matchesDependency) {
              if(dependency.resultingListValues && dependency.resultingListValues.length > 0) {
                dependencyListValues.push(parseStringToArray(dependency.resultingListValues));
              }
              if(dependency.isMakeRequired) {
                dependencyRequiresField = true;
              }
            }

            return matchesDependency;
          };

          const dependencyGroups = customField.customFieldDependencies.reduce((groups, dependency) => {
            const groupKey = dependency.fieldDependentOnId || '__ungrouped__';

            if (!groups[groupKey]) {
              groups[groupKey] = [];
            }

            groups[groupKey].push(dependency);
            return groups;
          }, {});

          const allDependenciesMet = Object.values(dependencyGroups).every((dependenciesForField) => {
            if (dependenciesForField.length === 1) {
              return evaluateDependency(dependenciesForField[0]);
            }

            return dependenciesForField.some(dependency => evaluateDependency(dependency));
          });

          displayfield = allDependenciesMet;
          return {
            hideInTable: !displayfield,
            isRequired: displayfield ? dependencyRequiresField : false,
            listValues: displayfield && dependencyListValues.length > 0 ? dependencyListValues[dependencyListValues.length - 1] : []
          };
        }
        return {
          hideInTable: false,
          isRequired: false,
          listValues: []
        };
      };

  const renderCustomFieldSummaries = (summaries) => {
    summaries.forEach(summary => {
        const inactiveField = getStatusType(summary.fieldStatusId) === 'inactive';
        const displayFieldMeta = inactiveField
          ? { hideInTable: true, isRequired: false, listValues: [] }
          : displayField(summary);

        customFieldSummaries.push({
            id: summary.customFieldCommonId,
            header: summary.fieldLabel,
            accessorKey: summary.fieldId,
            type: summary.fieldTypeId,
            hideInTable: displayFieldMeta.hideInTable,
            required: displayFieldMeta.isRequired || summary.isRequiredField,
            options: Array.isArray(displayFieldMeta.listValues) && displayFieldMeta.listValues.length > 0
              ? displayFieldMeta.listValues
              : (typeof summary.fieldListValues === 'string' && summary.fieldListValues.length > 0
                ? summary.fieldListValues.split(';')
                : []),
            value: summary.fieldValue,
            tab: 1,
        })        
    });
    return customFieldSummaries;
  }

  const updateFields = async (tab, values) => {
    setIsLoading(true);
    let newValues = [];

    if (customFieldValues && customFieldValues.length !== 0) {
        // add new field value to every custom field object

        for(var field of customFieldValues)
        {
            let f = { 
                customFieldValueId: field.customFieldValueId,
                fileId: field.fileId,
                customFieldCommonId: field.customFieldCommonId,
                fieldValue: String(values[field.fieldId] ?? ''),
                addedBy: field.addedBy ? field.addedBy : 1,
                addedOn: field.addedOn ? field.addedOn : new Date(),
                modifiedBy: field.modifiedBy ? field.modifiedBy : 1,
                modifiedOn: new Date()
             };
            newValues.push(f);
        }

        for(const val of newValues)
        {
            const resp = await props.updateAuthCustomFieldValue(val);
            if (resp.type === UPDATE_AUTH_CUSTOM_FIELD_VALUE_FAILURE) {
                props.showToast('Failed to update the employee custom field info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
                setIsLoading(false);
                return false;
            }
            setCustomFields(resp.response);
        }

        setIsLoading(false);
        return true;
    } 
  };

  return (
    <IterativeEditableCard
      tabs={customFieldTabs}
      summaries={renderCustomFieldSummaries(customFields)}
      numColumns={2}
      updateFields={updateFields}
      isLoading={isLoading}
      typeEnums={fieldTypes}
      statusEnums={fieldStatuses}
      hideEdit={Boolean(props.hideEdit)}
      setDataState={setCurrentFieldValues}
      dataState={currentFieldValues}
    />
  );
};

const mapStateToProps = state => {
  const { fieldStatuses, fieldTypes } = state.enumerations.allEnums;

  return {
    fieldStatusesEnum: fieldStatuses,
    fieldTypesEnum: fieldTypes,
  };
};

export default compose(
  connect(mapStateToProps, {
    updateAuthCustomFieldValue,
    showToast
  })
)(CustomFieldValuesCard);
